module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "content"
  }, [_c('link', {
    attrs: {
      "rel": "stylesheet",
      "href": "https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css",
      "integrity": "sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO",
      "crossorigin": "anonymous"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mb-3 d-flex"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Settings'
      }
    }
  }, [_c('el-button', {
    staticClass: " mr-5",
    attrs: {
      "plain": "",
      "size": "small"
    }
  }, [_c('span', {
    staticClass: "el-icon-arrow-left"
  }), _vm._v(" Back to Settings")])], 1), _vm._v(" "), (_vm.rooms && _vm.rooms.length) ? _c('el-button-group', _vm._l((_vm.rooms), function(room) {
    return _c('el-button', {
      key: room._id,
      attrs: {
        "type": room._id === (_vm.selectedRoom && _vm.selectedRoom._id) ? 'primary' : '',
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.selectRoom(room)
        }
      }
    }, [_vm._v(_vm._s(room.title))])
  }), 1) : _vm._e(), _vm._v(" "), _c('el-button-group', [_c('el-button', {
    attrs: {
      "type": "success",
      "size": "small"
    },
    on: {
      "click": _vm.createNewRoom
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("\n      Add room\n    ")]), _vm._v(" "), (_vm.selectedRoom) ? _c('el-button', {
    attrs: {
      "type": "danger",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.deleteRoom(_vm.selectedRoom)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-delete"
  }), _vm._v("\n      Delete current room\n    ")]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.selectedRoom) ? _c('manage-room', {
    attrs: {
      "room": _vm.selectedRoom
    },
    on: {
      "saved": _vm.save
    }
  }) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": 'Create new room',
      "visible": _vm.showCreateRoom
    },
    on: {
      "update:visible": function($event) {
        _vm.showCreateRoom = $event
      }
    }
  }, [_c('create-room-dialog', {
    attrs: {
      "item": _vm.newRoom
    },
    on: {
      "create": _vm.onCreateRoom
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f79514d"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/ManageRooms.vue
// module id = 419
// module chunks = 4